var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"container mx-auto"},[_c(_vm.component,{tag:"component"}),_c('div',{staticClass:"back-button-wrapper"},[_c('a',{on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("Back")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }